module.exports = "<div [id]=\"id\" #chartContainer style=\"height: 650px\"></div>\n";